<template>
    <CustomTopSheetDialog v-model="show" :width="600" :title="'Mehr Infos, bitte!'" :customclass="'text-center'">
        <v-list density="compact" class="more-Info-list" :slim="true">
            <v-list-item @click="openContactForm('producer')">
                <v-list-item-title class="text-left">{{$t('fairling.profile.contactRequest.contactBtn')}}</v-list-item-title>
                <template v-slot:prepend>
                    <CustomIcon :type="'none'" :iconName="`iconContact`" :fileType="'svg'"></CustomIcon>
                </template>
            </v-list-item>
            <v-list-item @click="openContactForm('pattern')">
                <v-list-item-title class="text-left">{{$t('fairling.profile.contactRequest.sampleBtn')}}</v-list-item-title>
                <template v-slot:prepend>
                    <CustomIcon :type="'none'" :iconName="`iconSample`" :fileType="'svg'"></CustomIcon>
                </template>
            </v-list-item>
            <v-list-item @click="openContactForm('order')">
                <v-list-item-title class="text-left">{{$t('fairling.profile.contactRequest.orderBtn')}}</v-list-item-title>
                <template v-slot:prepend>
                    <CustomIcon :type="'none'" :iconName="`iconOrder`" :fileType="'svg'"></CustomIcon>
                </template>
            </v-list-item>
        </v-list>
    </CustomTopSheetDialog>

    <v-dialog v-model="showContactForm" transition="dialog-top-transition" max-width="410px">
        <v-card class="contact-form-card">
            <v-card-item class="pa-2">
                <v-card-title color="#52b8d3">
                    <div class="text-center" color="#52b8d3">
                        <span class="text-center">{{ ShowContactFormTitle }}</span>
                    </div>
                </v-card-title>
            </v-card-item>

            <v-card-text class="pa-4" min-height="210px">
                <v-label v-if="contactType == 'order'" class="contact-form-label">{{$t('fairling.profile.contactRequest.messageLabel.order')}}
                </v-label>
                <v-label v-else class="contact-form-label">{{$t('fairling.profile.contactRequest.messageLabel.contact',{merchantName:merchant?.name})}}</v-label>
                <v-textarea class="contact-form-input" hide-details="true" density="compact" variant="outlined"
                    rows="10"></v-textarea>
                <v-label class="contact-form-label">{{$t('fairling.profile.contactRequest.emailAddress')}}</v-label>
                <v-text-field class="contact-form-input" v-model="contactMail" hide-details="true" density="compact"
                    variant="outlined"></v-text-field>
            </v-card-text>

            <v-card-actions class="justify-end">
                <v-btn variant="flat" size="large" color="primary" rounded="lg" class="white--text mb-2 w-100"
                    @click="openTopSheet">{{$t('fairling.profile.contactRequest.submit')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>


<script>
export default {
    name: "ConfirmDeletionDialog",
    props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
        merchant:{
            type: Object,
            required:true
        }
    },
    data() {
        return {
            showContact: false,
            showContactForm: false,
            ShowContactFormTitle: '',
            contactType: null,
            contactMail: null,
        }
    },
    computed: {
        show: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },
    methods: {
        openContactForm(type) {
            this.contactMail = this.$user.value.email;
            this.contactType = type;
            this.show = false;

            switch (type) {
                case 'producer':
                    this.ShowContactFormTitle = 'Hersteller anfragen'
                    break;
                case 'pattern':
                    this.ShowContactFormTitle = 'Muster anfordern'
                    break;
                case 'order':
                    this.ShowContactFormTitle = 'Produkte bestellen'
                    break;
                default:
                    break;
            }
            this.showContactForm = true;
        },
        closeSheet() {
            this.show = false;
        },
    },
};
</script>
<script setup>
import { ref, defineEmits } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';


 
</script>
<style scoped>
.more-Info-list .v-list-item:hover {
    color: unset;
}

.more-Info-list {
    font-weight: 500;
    font-size: 16px;
    color: #52b8d3;
}

.contact-form-label {
    padding-left: 15px;
    font-size: 13px;
    font-weight: 200;
    color: gray;
    margin-top: 5px;
    margin-bottom: 5px;
    white-space: normal;
}

.contact-form-card .v-card-item .v-card-title {
    font-size: 14px;
}

.contact-form-card .v-card-item {
    background-color: #52b8d3;
    color: white;
}

.contact-form-input {
    font-size: 14px;
    font-weight: 300;
}
</style>
